(() => {
  if (customElements.get('keychain-personalization')) return;

  class KeychainPersonalization extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const initialize = () => {
        if (!this.isConnected) return;
        this.photo = this.querySelector('[data-photo-input]');
        this.petName = this.querySelector('[data-pet-name]');
        this.error = this.querySelector('[role="alert"]');
        this.backgrounds = [...this.querySelectorAll('[data-background-option]')];
        if (!this.photo || !this.petName || !this.backgrounds.length) return;
        const { signal } = this.controller;
        this.preview?.destroy();
        if (window.EchoesKeychainPreview) this.preview = new window.EchoesKeychainPreview(this);
        this.photo.addEventListener('change', () => {
          this.validate();
          this.preview?.setPhoto(this.photo.files[0]);
        }, { signal });
        this.petName.addEventListener('input', () => {
          this.petName.setCustomValidity('');
          this.preview?.schedule();
        }, { signal });
        this.backgrounds.forEach(radio => radio.addEventListener('change', () => this.updateBackground(), { signal }));
        this.ownerDocument.addEventListener('submit', event => {
          if (event.target.getAttribute('id') !== this.dataset.formId) return;
          this.updateBackground();
          if (this.validate()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.invalidField.reportValidity();
        }, { capture: true, signal });
        this.updateBackground();
        this.dataset.initialized = 'true';
      };
      if (this.querySelector('[data-photo-input]')) initialize();
      else queueMicrotask(initialize);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.preview?.destroy();
    }

    updateBackground() {
      const selected = this.backgrounds.find(radio => radio.checked);
      if (!selected) return;
      this.backgrounds[0].setCustomValidity('');
      this.querySelector('[data-selected-background]').textContent = selected.value;
      const preview = this.querySelector('[data-background-preview]');
      preview.src = selected.dataset.artwork;
      preview.alt = `${selected.value} watercolor background`;
      this.querySelector('[data-background-caption]').textContent = preview.alt;
      this.preview?.schedule();
    }

    validate() {
      const file = this.photo.files[0];
      let photoError = '';
      if (!file) photoError = 'Please upload a photo of your pet before adding this item to your cart.';
      else if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) photoError = 'Please choose a JPG, PNG or WEBP photo.';
      else if (file.size > 10 * 1024 * 1024) photoError = 'Please choose a photo smaller than 10 MB.';
      this.photo.setCustomValidity(photoError);

      const nameError = this.petName.value && !/^[\p{Script=Latin}\p{M}0-9\s.'’&-]+$/u.test(this.petName.value)
        ? 'Please use Latin letters for the printed pet name.' : '';
      this.petName.setCustomValidity(nameError);

      const backgroundError = this.backgrounds.some(radio => radio.checked) ? '' : 'Please choose a background color.';
      this.backgrounds[0].setCustomValidity(backgroundError);
      const message = photoError || nameError || backgroundError;
      this.error.textContent = message;
      this.error.hidden = !message;
      this.invalidField = photoError ? this.photo : nameError ? this.petName : this.backgrounds[0];
      return !message;
    }
  }

  customElements.define('keychain-personalization', KeychainPersonalization);
})();
